module.exports = __webpack_public_path__ + "img/sd.e32c583d.svg";